import React, {useMemo} from 'react';
import {FilterDef, FinalTable, FinalTableColumn, FinalTableFiltersDef, useFinalTable} from '@mc/ui-v4';
import {GridDtmPrenosZarizeniVO, GridFilterDtmPrenosZarizeniVO, MapioDtmApi} from '../../api';
import {getDtmDetailUrl} from '../../utils/urlRedirectUtils';
import {DTM_ZARIZENI_FT_KEY} from '../../const/FinalTableKeys';
import {DTM_ZARIZENI_SETTINGS_KEY} from '../../const/SettingsKeys';
import {DataRequestVO, DataResponseVO} from '@mc/data-filter-react';
import {getEnumSkupinaPrenosDtmCaption} from '../../enums/EnumSkupinaPrenosDtm';

type Props = {id: number};
export const DtmObjektyDetail: React.FC<Props> = ({id}) => {
    const filters = React.useMemo<FinalTableFiltersDef>(() => {
        const filtersDef: FilterDef[] = [
            {
                name: 'nazev',
                type: 'text',
                label: 'Název objektu',
            },
        ];
        return {filtersDef};
    }, []);

    const columns = useMemo<FinalTableColumn<GridDtmPrenosZarizeniVO>[]>(() => {
        return [
            {
                header: 'Název objektu',
                accessor: 'nazev',
                type: 'text',
                width: '50%',
                sortable: true,
                groupable: true,
            },
            {
                header: 'Skupina DTM',
                accessor: 'skupina',
                type: 'text',
                width: '50%',
                sortable: true,
                groupable: true,
                cell: ({row}) => (row?.skupina ? getEnumSkupinaPrenosDtmCaption(row?.skupina) : ''),
            },
        ];
    }, []);

    const dtmPrenosFinalTable = useFinalTable<GridDtmPrenosZarizeniVO, GridFilterDtmPrenosZarizeniVO, number>(`${DTM_ZARIZENI_FT_KEY}_${id}`, {
        settingsKey: DTM_ZARIZENI_SETTINGS_KEY,
        api: async (request: DataRequestVO<GridFilterDtmPrenosZarizeniVO>): Promise<DataResponseVO<GridDtmPrenosZarizeniVO>> =>
            (await MapioDtmApi.findPrenosZarizeniByFilter(id, request)).data,
        filters,
        columns,
    });

    return (
        <FinalTable<GridDtmPrenosZarizeniVO, GridFilterDtmPrenosZarizeniVO, number>
            className={'w-100'}
            title={'Přehled změn DTM'}
            finalTableProps={dtmPrenosFinalTable}
            getRowProps={({row}) => {
                const to = row && getDtmDetailUrl(row?.id);
                return {
                    link: {to},
                };
            }}
        />
    );
};
